/**
 * Medidas do layout do celular que o TypeScript precisa saber (enquadramento,
 * fichas, legenda). As mesmas larguras estão em `--trilho-largura` e
 * `--trilho-fim` (src/index.css); mudando uma, mude a outra.
 *
 * Em pé (360 × 640): a linha do topo em y 12 (a marca, "Pesquisar" no meio
 * e a casa), o trilho de camadas na borda esquerda a partir de y 64, a coluna
 * de botões na direita (voltar, "⋯", últimos focos, "Próximos dias") e, no pé
 * do mapa, uma linha só (ui/RelogioDoPe): o relógio e o período à esquerda, o
 * play no meio e a previsão das nuvens à direita. Tudo a 8 px das bordas.
 * Deitado (pouca altura): o trilho vira duas colunas e ocupa a altura toda;
 * a marca e a linha do pé começam à direita dele (29/10/2026).
 */

/** A regra do `useIsMobile`: menos de 768 px de largura, ou celular deitado (pouca altura e toque). */
export const CONSULTA_CELULAR = '(max-width: 767px), (max-height: 500px) and (pointer: coarse)';

/** Dentro do celular, a tela deitada: o trilho em duas colunas (a variante `deitado:` do index.css). */
export const CONSULTA_DEITADO = '(max-height: 500px)';

/** Distância das bordas do mapa (px) do trilho, do chip e da coluna de botões. */
export const BORDA_PX = 8;

/** Largura do trilho (px): um botão de 40 px, ou dois deitado, com a borda e o respiro. */
export const LARGURA_DO_TRILHO = { emPe: 44, deitado: 86 } as const;

/** Onde começa o que fica à direita do trilho (px): a borda, o trilho e 8 px. */
export const FIM_DO_TRILHO = {
  emPe: BORDA_PX + LARGURA_DO_TRILHO.emPe + 8,
  deitado: BORDA_PX + LARGURA_DO_TRILHO.deitado + 8,
} as const;

/** Botão da coluna da direita (px) e o vão entre dois deles. */
export const BOTAO_DA_COLUNA_PX = 44;
export const VAO_DA_COLUNA_PX = 8;

/**
 * Fim da coluna da direita (px do topo do mapa): voltar, "⋯", últimos focos e
 * "Próximos dias", a partir de y 12 (no modo da previsão os focos saem e ela
 * sobe; a legenda observada, que usa esta medida, não aparece no modo).
 */
export const FIM_DA_COLUNA_PX = 12 + 4 * BOTAO_DA_COLUNA_PX + 3 * VAO_DA_COLUNA_PX;

function consulta(q: string): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.(q).matches;
}

/** No layout do celular? (o mesmo que o `useIsMobile`, fora do React). */
export function noCelular(): boolean {
  return consulta(CONSULTA_CELULAR);
}

/** No celular deitado? */
export function celularDeitado(): boolean {
  return noCelular() && consulta(CONSULTA_DEITADO);
}
